<template>
  <v-card>
    <v-card-text v-if="calls.length > 0">
      <v-simple-table light>
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Caller</th>
            <th>Outcome</th>
            <th>Note</th>
            <th style="width: 145px;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="call in calls" :key="call.id">
            <td>{{ call.callTime | readableDateTime }}</td>
            <td>{{ call.callType.name }}</td>
            <td>{{ call.caller.firstName + " " + call.caller.lastName }}</td>
            <td>{{ callOutcomes.filter(element => {return element.value === call.callOutcome})[0].text }}</td>
            <td>{{ call.note }}</td>
            <td>
              <v-btn small @click="$emit('edit-call', call);" class="info"><v-icon medium>mdi-pencil</v-icon></v-btn>
              <v-btn small @click="$emit('delete-call', call);" class="error ml-2"><v-icon medium>mdi-trash-can</v-icon></v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-text v-else>
      <v-alert type="info">No calls currently logged</v-alert>
    </v-card-text>
    <v-card-actions v-if="showActions">
      <v-btn @click="$emit('log-call');">Log Call</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DealLoggedCallList",
  props: {
    calls: {
      type: Array,
      required:true
    },
    callOutcomes: {
      type: Array,
      required:true
    },
    showActions: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>